import { Controller } from 'stimulus'

// Sizes the board to the viewport height so its horizontal scrollbar sits at the bottom of the screen,
// whether the columns are short or long (long ones scroll vertically inside the board).
export default class extends Controller {
  connect() {
    this.fit = this.fit.bind(this)
    window.addEventListener('resize', this.fit)
    this.fit()
  }

  disconnect() {
    window.removeEventListener('resize', this.fit)
  }

  fit() {
    const top = this.element.getBoundingClientRect().top + window.scrollY
    this.element.style.height = `${Math.max(window.innerHeight - top - 16, 320)}px`
  }
}
